import React from "react";

type CheckIconProps = {
  enabled: boolean | undefined;
};

const CheckIcon: React.FC<CheckIconProps> = ({ enabled }) => {
  if (enabled) {
    return <i className="pi pi-check text-green-500" />;
  }
  return <i className="pi pi-times text-red-500" />;
};

export default CheckIcon;
